import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  // Link,
  // useHistory,
  // useLocation,
} from "react-router-dom";

import HomePage from "./pages/publicPages/home";
import Login from "./pages/publicPages/login";
import { PrivateRoute } from "./lib/router";
import { ProvideAuth } from "./lib/auth";
import "./App.scss";
import ProtectedRoutes from "./lib/protectedRoutes";
import UserProvider from "./providers/UserProvider";
import MeetingListProvider from "./providers/MeetingListProvider";
import ActiveRoomProvider from "./providers/ActiveRoomProvider";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateAdapter from "@mui/lab/AdapterMoment";
import {
  ThemeProvider,
  StyledEngineProvider,
  createTheme,
} from "@mui/material/styles";

if (localStorage.getItem("language") === "fa") {
  import("./rtl.scss");
}

const theme = createTheme();

export default function App() {
  // let { path, url } = useRouteMatch();

  // useEffect(() => {
  //     // Include the Crisp code here, without the <script></script> tags
  //     window.$crisp = [];
  //     window.CRISP_WEBSITE_ID = "81c02607-d402-4cd0-8634-d34171c10a79";
  //     (function () {
  //         var d = document;
  //         var s = d.createElement("script");
  //         s.src = "https://client.crisp.chat/l.js";
  //         s.async = 1;
  //         d.getElementsByTagName("head")[0].appendChild(s);
  //     })();
  // }, []);

  return (
    <Suspense fallback="Loading ...">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <UserProvider>
            <MeetingListProvider>
              <ActiveRoomProvider>
                <ProvideAuth>
                  <LocalizationProvider dateAdapter={DateAdapter}>
                    <Router>
                      <Switch>
                        <Route path="/public">
                          <HomePage />
                        </Route>
                        <Route
                          exact={true}
                          path="/"
                          render={() => <Redirect to="/login" />}
                        />
                        <Route path="/login">
                          <Login />
                        </Route>
                        <PrivateRoute>
                          <Route>
                            <ProtectedRoutes />
                          </Route>
                        </PrivateRoute>
                      </Switch>
                    </Router>
                  </LocalizationProvider>
                </ProvideAuth>
              </ActiveRoomProvider>
            </MeetingListProvider>
          </UserProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </Suspense>
  );
}
